require('./bootstrap');

import 'core-js/stable';
import './layouts/index';